export default __webpack_public_path__ + "static/media/Links-BlankIMGs-03.9d37e9e4.svg";